/* eslint-disable max-len */

export enum atomicsViewNames {
  missing = 'missing',
  ryp = 'ryp',
  spinner = 'spinner',
  addressNormalizationShippingInterstitial = 'address_normalization_shipping_interstitial',
  addressNormalizationShippingAndBillingInterstitial = 'address_normalization_shipping_and_billing_interstitial',
  residentialAddressInterstitial = 'residential_address_interstitial',
  phoneConfirmationMultiFieldInterstitial = 'phone_confirmation_multi_field_interstitial',
  phoneConfirmationSCAInterstitial = 'phone_confirmation_sca_interstitial',
  fiLimitExceededInterstitial = 'fi_limit_exceeded_interstitial',
  memberBenefitsGuestInterstitial = 'member_benefits_guest_interstitial',
  sepaInterstitial = 'sepa_interstitial',
}

export enum atomicsTasks {
  missing = 'missing',
  addressNormalizationShipping = 'contingency_address_norm_recommendation_shipping',
  addressNormalizationShippingAndBilling = 'contingency_address_norm_recommendation_shipping_and_billing',
  selectContinueAsGuest = 'select_continue_as_guest',
  selectCreateAccountAndContinue = 'select_create_account_and_continue',
  selectAgreeAndCreateAccountContinuePayLater = 'select_agree_and_create_account_pay_later',
  // task representing the whole guest or sign up transaction
  rypLoaded = 'ryp_loaded',
  addResidentialAddress = 'add_residential_address',
  contingencySepaInterstitial = 'contingency_sepa_interstitial',
  contingencyMemberBenefitsGuest = 'contingency_account_benefits_user_input',
  contingencyFILimitExceeded = 'contingency_fi_limit_exceeded',
  contingencyPhoneConfirmation = 'contingency_phone_confirmation',
}

export enum atomicsCi {
  missing = 'missing',
  addressNormalizationShippingCancel = atomicsTasks.addressNormalizationShipping +
    '_cancel',
  addressNormalizationShippingSubmit = atomicsTasks.addressNormalizationShipping +
    '_submit',
  addressNormalizationShippingAndBillingCancel = atomicsTasks.addressNormalizationShippingAndBilling +
    '_cancel',
  addressNormalizationShippingAndBillingContinue = atomicsTasks.addressNormalizationShippingAndBilling +
    '_continue',
  addressNormalizationShippingAndBillingSubmit = atomicsTasks.addressNormalizationShippingAndBilling +
    '_submit',
  clickContinueAsGuestButton = 'click_continue_as_guest_button',
  clickCreateAccountAndContinueButton = 'click_create_account_and_continue_button',
  //add residential address interactions
  clickEditResidentialAddressButton = 'click_edit_residential_address_button',
  clickSaveResidentialAddressButton = 'click_save_residential_address_button',
  clickSaveAndContinueResidentialAddressButton = 'click_save_and_continue_residential_address_button',
  clickCloseResidentialAddressInterstitial = 'click_close_residential_address_interstitial',
  //sepa compliance flow interactions
  clickSepaDirectDebitLink = 'click_sepa_direct_debit_link',
  clickSepaInterstitialCloseButton = 'click_sepa_interstitial_close_button',
  clickSepaInterstitialOkButton = 'click_sepa_interstitial_ok_button',
  //paylater guest flow for UK ,IT ,AU,FR interaction
  clickGuestSelectPayLaterOptionsLink = 'select_pay_later_options_link',
  clickAgreeAndCreateAccountPayLaterButton = 'click_agree_and_create_account_pay_later',
  //member benefits true interactions
  memberBenefitsCheckoutAsMember = atomicsTasks.contingencyMemberBenefitsGuest +
    '_checkout_as_member',
  memberBenefitsCheckoutAsGuest = atomicsTasks.contingencyMemberBenefitsGuest +
    '_checkout_as_guest',
  memberBenefitsCancel = atomicsTasks.contingencyMemberBenefitsGuest +
    '_cancel',
  // fi limit exceeded interactions
  clickFILimitExceededClose = atomicsTasks.contingencyFILimitExceeded +
    '_cancel',
  clickFILimitExceededContinue = atomicsTasks.contingencyFILimitExceeded +
    '_continue',
  clickFILimitExceededTryADifferentCard = atomicsTasks.contingencyFILimitExceeded +
    '_try_a_different_card',
  // phone confirmation contingency interactions
  phoneConfirmationExceededLimitErrorContinue = atomicsTasks.contingencyPhoneConfirmation +
    '_exceeded_limit_error_continue',
  phoneConfirmationExceededLimitSCAErrorContinue = atomicsTasks.contingencyPhoneConfirmation +
    '_excceded_limit_sca_error_continue',
}

export enum atomicsFlows {
  guestAndSignup = 'guest',
}

export enum atomicsStatus {
  ok = 'Ok',
  error = 'Error',
  fci = 'FCI',
  start = 'Start',
}

export enum atomicsErrorReason {
  none = 'None',
  server = 'Server',
  flag = 'Flag',
  user = 'User',
  thirdParty = 'ThirdParty',
  network = 'Network',
  application = 'Application',
  auth = 'Auth',
}

export enum atomicsErrorContexts {
  addressNormalization = 'ADDRESS_NORMALIZATION_INTERSTITIAL',
  fiLimitExceeded = 'FI_LIMIT_EXCEEDED',
  invalidFormSubmission = 'INVALID_FORM_SUBMISSION',
  invalidResidentialAddress = 'INVALID_RESIDENTIAL_ADDRESS_IN_INTERSTITIAL',
  shippingCallback = 'SHIPPING_CALLBACK',
  shippingRegionUnsupported = 'SHIPPING_REGION_UNSUPPORTED',
  memberBenefitsTrueGuest = 'MEMBER_BENEFITS_TRUE_GUEST',
}

export const atomicsDomain = 'xo_legacy_guest';

/** Locally defined list of interactions, tasks, and viewNames. */
export const policy = {
  flows: Object.values(atomicsFlows),
  interactions: Object.values(atomicsCi),
  tasks: Object.values(atomicsTasks),
  viewNames: Object.values(atomicsViewNames),
};

/** Attributes for clickable components */
export type AtomicEventsAttributes = {
  domain?: typeof atomicsDomain;
  flow?: atomicsFlows;
  intent: atomicsCi;
  task?: atomicsTasks;
  viewName: atomicsViewNames;
};
